import * as Library from '../../../core/library/index';
import { Guid } from '../../../core/common/guid';

export class RtiAuthenticationService {
  public getToken(): string {
    return localStorage.getItem('token') || Guid.NEW();
  }

  public isAuthenticated(): boolean {
    const token = this.getToken();
    return this._tokenExpired(token);
  }

  private _tokenExpired(token): boolean {
    return false;
  }

  constructor() {
  }
}
